import { render, staticRenderFns } from "./FleetInformation.vue?vue&type=template&id=2edaf5b2"
import script from "./FleetInformation.vue?vue&type=script&lang=js"
export * from "./FleetInformation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports